export default {
  title: "Выходим из личного кабинета...",
  error: "Возникла серверная ошибка при выходе."
};
